<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col sm="7" lg="9">
          <div :class="['form-group', isInvalid('value') ? 'has-danger' : '']">
            <label
                    for="customFieldValue_value"
                    class="form-control-label">{{$t('views.excmcasetype.form.customField.customFieldValue.value')}}:</label>
            <input
                    id="customFieldValue_value"
                    v-model="item.value"
                    :class="['form-control', isInvalid('value') ? 'is-invalid' : '']"
                    type="text"
                    placeholder="">
            <div
                    v-if="isInvalid('value')"
                    class="invalid-feedback">{{ value }}</div>
          </div>
        </b-col>
        <b-col sm="5" lg="3">
          <div :class="['form-group', isInvalid('defaultValue') ? 'has-danger' : '']">
            <label
                    for="customFieldValue_defaultValue"
                    class="form-control-label">{{$t('views.excmcasetype.form.customField.customFieldValue.defaultValue')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="customFieldValue_defaultValue" button-variant="outline-primary" v-model="item.defaultValue" name="customFieldValue_defaultValue">
                <b-form-radio :value="0" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="1" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <div
                    v-if="isInvalid('defaultValue')"
                    class="invalid-feedback">{{ defaultValue }}</div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'CustomFieldValueForm',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    isInvalid (key) {
      // return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
